<template>
  <div>
    <h5 class="text-center text-darked p-3 m-0">
      {{ skillName }} 
    </h5>
    <p class="m-0 text-muted">
      Complete the answers.
    </p>
    <!-- <small class="text-muted">
      -- All fields are required
    </small> -->
    <hr class="my-2" />
    <b-form v-on:submit.prevent="validateSendData()" class="container">
      <span v-for="(item, idx) in questions" :key="idx">
        <multiple-choice
          v-if="item.type_question == '1' && showQuestions(item.id)"
          :options="item.option_answers"
          :question="item.question"
          :questionPlan="item.related_plan_question && item.parent_reponses?item.related_plan_question:null"
          :index="idx + 1"
          :id="item.id"
          :answers="item.answers"
          :ref="`question${item.id}`"
          class="mb-3"
        />
        <single-choice
          v-if="item.type_question == '2' && showQuestions(item.id)"
          :options="item.option_answers"
          :question="item.question"
          :questionPlan="item.related_plan_question && item.parent_reponses?item.related_plan_question:null"
          :index="idx + 1"
          :id="item.id"
          :answers="item.answers"
          :ref="`question${item.id}`"
          class="mb-3"
        />
        <range
          v-if="item.type_question == '3' && showQuestions(item.id)"
          :min_value="item.min_value"
          :max_value="item.max_value"
          :min_label="item.min_label"
          :max_label="item.max_label"
          :question="item.question"
          :questionPlan="item.related_plan_question && item.parent_reponses?item.related_plan_question:null"
          :index="idx + 1"
          :id="item.id"
          :answers="item.answers"
          :ref="`question${item.id}`"
          class="mb-3"
        />

        <open-answer
          v-if="item.type_question == '4' && showQuestions(item.id)"
          :question="item.question"
          :questionPlan="item.related_plan_question && item.parent_reponses?item.related_plan_question:null"
          :index="idx + 1"
          :id="item.id"
          :answers="item.answers"
          :ref="`question${item.id}`"
          class="mb-3"
        />

        <fill-table
          v-if="item.type_question == '5' && showQuestions(item.id)"
          :column_1="item.column_1"
          :column_2="item.column_2"
          :question="item.question"
          :questionPlan="item.related_plan_question && item.parent_reponses?item.related_plan_question:null"
          :index="idx + 1"
          :id="item.id"
          :answers="item.answers"
          :ref="`question${item.id}`"
          class="mb-3"
        />

        <fill-time
          v-if="item.type_question == '6' && showQuestions(item.id)"
          :question="item.question"
          :questionPlan="item.answers?setRelatedQuestion(item.id):null"
          :index="idx + 1"
          :id="item.id"
          :answers="item.answers"
          :ref="`question${item.id}`"
          class="mb-3"
        />
      </span>
      <b-button type="submit" variant="warning" class="my-3" block>
        Save
      </b-button>
    </b-form>
    <modal-congrats
      ref="modalCongrats"
      :skill="skillName"
      :router="goComponent"
      :points="poinstToShow"
    />
  </div>
</template>
<script>
import multipleChoice from "@/components/planning/question/multipleChoice.vue";
import singleChoice from "@/components/planning/question/singleChoice.vue";
import range from "@/components/planning/question//range.vue";
import openAnswer from "@/components/planning/question/openAnswer.vue";
import fillTable from "@/components/planning/question/fillTable.vue";
import fillTime from "@/components/planning/question/fillTime.vue";
import modalCongrats from "@/components/general/modalCongrats.vue";
import { mapGetters, mapActions } from "vuex";

export default {
  components: {
    multipleChoice,
    singleChoice,
    range,
    openAnswer,
    fillTable,
    fillTime,
    modalCongrats
  },
  props: {
    skillQuest: Array,
    Mid: String,
    skillName: String
  },
  data() {
    return {
      hideQuestions: [],
      modalQuestion: false,
      poinstToShow: "0",
      questions: []
    };
  },
  methods: {
    ...mapActions("planning", [
      "createSkillPractice",
      "FetchRelatedPlanAnswers"
    ]),
    showQuestions(qid) {
      let show = true;
      qid = parseInt(qid, 10);
      this.hideQuestions.forEach(element => {
        if (element == qid) {
          show = false;
        }
      });
      return show;
    },
    goComponent() {
      // this.$router.go(0);
      this.$router.replace({
        path: "/plan-select-skill?type=check"
      });
    },
    setRelatedQuestion(qid) {
      this.FetchRelatedPlanAnswers({
        parent: this.getUserId,
        questions: [qid]
      });
    },
    validateSendData() {
      let answers = [];
      this.skillQuest.forEach(element => {
        let id = parseInt(element.id, 10);
        if (this.$refs["question" + id] && this.showQuestions(id)) {
          let vueComponent = this.$refs["question" + id][0];
          switch (element.type_question) {
            case "1":
              vueComponent.selected.forEach(itemSelected => {
                answers.push({
                  question: id,
                  answer: itemSelected
                });
              });
              break;
            case "2":
            case "3":
              answers.push({
                question: id,
                answer: vueComponent.selected
              });
              break;
            case "4":
              answers.push({
                question: id,
                answer: vueComponent.inputData
              });
              break;
            case "5":
              vueComponent.tableRows.forEach(itemSelected => {
                answers.push({
                  question: id,
                  answer: itemSelected.column1,
                  additional_data: itemSelected.column2
                });
              });
              break;
            case "6":
              answers.push({
                question: id,
                answer: vueComponent.value
              });
              break;
            default:
              console.log("Is Other");
              break;
          }
        }
      });
      this.createSkillPractice({
        parent: this.getUserId,
        answers: answers
      }).then(response => {
        this.poinstToShow = response;
        this.$refs.modalCongrats.showModalCongrats = true;
      });
    },
    descSort(a,b) {
      if (a.order && b.order) {
        if (a.order > b.order) {
          return 1;
        }
        if (a.order < b.order) {
          return -1;
        }
      }
      return 0;
    }
  },
  computed: {
    ...mapGetters("planning", ["getRelatedPlanAnswers", "getPracticeAnswers"]),
    ...mapGetters("user", ["getUserId"])
  },
  beforeMount() {
    // this.questions=[]
    if (
      this.getPracticeAnswers != null &&
      this.getPracticeAnswers.length != 0
    ) {
      this.getPracticeAnswers.forEach(answer => {
        this.skillQuest.forEach(question => {
          if (answer.id == question.id) {
            question["answers"] = answer.parent_reponses;
            this.questions.push(question);
          }
        });
      });

      this.questions.sort((a,b)=>this.descSort(a,b))
    }
  }
};
</script>
